import type { PurchaseReportTransactionSource } from "@snackpass/snackpass-types";
import { t } from '@lingui/core/macro';

export const TRANSACTION_SOURCES: PurchaseReportTransactionSource[] = [
    "app",
    "kiosk",
    "online",
    "thirdParty",
    "register",
];

export const getDefinedSources = (): {
    label: string;
    value: PurchaseReportTransactionSource;
}[] => [
    {
        label: t`App`,
        value: "app",
    },
    {
        label: t`Kiosk`,
        value: "kiosk",
    },
    {
        label: t`Online`,
        value: "online",
    },
    {
        label: t`Integration`,
        value: "thirdParty",
    },
    {
        label: t`Register`,
        value: "register",
    },
];
